module.exports = __webpack_public_path__ + "img/CardNFT01.a8e6734f.png";